<template>
  <div class="vendor-signup-wrapper">
    <h5 data-test="agentLoginWindowHeading" id="agentLoginWindowHeading">Be an agent on Womenpower?</h5>
    <p data-test="agentLoginWindowPara" id="agentLoginWindowPara">Introduce a vendor to us in less than 10 minutes!</p>
    <form data-vv-scope="login">
      <div class="form-group">
        <label for="exampleInputEmail1"
															data-test="agentLoginWindowLabel"
															id="agentLoginWindowLabel">Enter your email address</label>
        <input
          v-validate="'required|email'"
          name="agent Email"
          :class="(showLoginError &&
          errors.has('login.agent Email'))?'is-invalid':''"
          v-model="account.email"
          type="text"
          class="form-control"
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          placeholder="Enter email"
										data-test="agentLoginWindowEmailInput"
        >
        <div
          class="invalid-feedback"
          v-if="(errors.has('login.agent Email') && showLoginError)"
          id="login-form-email-error"
										data-test="agentLoginWindowEmailInputError"
        >
          {{ errors.first('login.agent Email') }}
          <!--Agent email is required-->
        </div>
        <small
          id="emailHelp"
          class="form-text text-muted"
										data-test="agentLoginWindowEmailHelp"
        >We'll never share your email with anyone else.
        </small>
      </div>
      <button
        type="submit"
        class="btn btn-primary btn-type-primary"
        @click.prevent="action('login')"
								data-test="agentLoginWindowSubmitButton"
								id="agentLoginWindowSubmitButton"
      >{{ apiCallActive ? 'Connecting...' : 'Continue'}}
      </button>
    </form>

    <!-- Login modal -->
    <agent-login-modal
      :email="account.email"
      @agentLoginViaPassword="agentLoginViaPassword($event)"
    >
    </agent-login-modal>
    <!-- Login modal -->
    <!-- Modal -->
    <agent-sign-up-modal
      :enableExistingUserForm="existingUser"
      :agentAccount="account"
      @agentsignUp="agentSignup($event)"
      @agentUpdateAndLogin="updateAgentAndLogin($event)"
    >
    </agent-sign-up-modal>
    <!-- Modal -->
    <!--<vendor-gst-modal>-->
    <!--</vendor-gst-modal>-->
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AgentLoginModal from '@/components/pages/Agent/newAgent/AgentLoginModal'
import AgentSignUpModal from '@/components/pages/Agent/newAgent/AgentSignUpModal'
import { vendorApis } from '@/services/ApiServices/vendorApis'
import { agentApis } from '@/services/ApiServices/agentApis'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
const initialState = () => {
	return {
		account: {
			email: ''
		},
		showLoginError: false,
		existingUser: false,
		apiCallActive: false
	}
}
export default {
	name: 'agent-login-window',
	components: {
		// VendorGstModal,
		AgentLoginModal,
		AgentSignUpModal
	},
	data () {
		return initialState()
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						this.showLoginError = false
						this.verifyClientStatus(this.account)
					} else {
						this.showLoginError = true
					}
				})
		},
		agentSignup (agentData) {
			vendorApis.agentSignUp(agentData)
				.then((res) => {
					Object.assign(this.$data, initialState())
				})
				.catch((e) => {
					if (e.status === 412) {
						this.$toasted.show('You are already a agent, Please login', { icon: 'exclamation-circle' })
						$('#AgentLoginModal').modal('show')
					} else {
						this.$toasted.show(e.data.message, { icon: 'exclamation-circle' })
					}
				})
		},
		async verifyClientStatus (clientData) {
			try {
				const userStatus = await authenticationApi.verifyClient(clientData)
				if (userStatus) {
					if (userStatus.agent === false && userStatus.customer === false) {
						$('#AgentSignUpModal').modal('show')
					} else if (userStatus.agent === false && userStatus.customer === true) {
						this.existingUser = true
						$('#AgentSignUpModal').modal('show')
					} else {
						$('#AgentLoginModal').modal('show')
					}
				}
			} catch (err) {
				// error handling
			}
		},
		async updateAgentAndLogin (clientData) {
			const { address_line1, address_line2, identity_proof, documents, password } = clientData
			const userData = {
				address_line1,
				address_line2,
				identity_proof,
				documents,
				password,
				agent_name: clientData.username,
				username: clientData.email
			}
			this.agentLoginViaPassword(userData)
		},
		async agentLoginViaPassword (userData) {
			try {
				$('#AgentLoginModal').modal('hide')
				this.apiCallActive = true
				await agentApis.agentLogin(userData)
				Object.assign(this.$data, initialState())
			} catch (err) {
				this.apiCallActive = false
				// error handling
			}
		}
	}
}
</script>
